import React from 'react';
import Layout from 'components/layout';
import SEO from 'components/seo';

// Component
import TextImageBlock from 'components/organisms/Blocks/TextImageBlock/TextImageBlock';
import Hero from 'components/molecules/Hero/Hero';

// Data
import WoonVloerenData from 'data/WoonVloerenPage.json';

const WoonVloerenPage = () => (
  <Layout>
    <TextImageBlock
      data={WoonVloerenData.intro}
    />
    <Hero
      modifier="inPage"
      {...WoonVloerenData.inPageHero}
    />
  </Layout>
);
export default WoonVloerenPage;

export const Head = () => (
  <SEO title="Woonvloeren" />
);
